import { dispatch } from "@store/index";
import { reset, update } from "@store/reducers/user";
import axios, { AxiosRequestConfig } from "axios";
import { isObject, set } from "lodash";
import { deleteToken, getToken, saveToken } from "./auth";
import { getEnvironment } from "./environtment";
import { queryClient } from "./query";
import OneSignal from "react-onesignal";

class API {
  accessToken: string | null = null;
  baseURL: string = "";

  constructor() {
    this.initialize();
  }

  initialize() {
    this.accessToken = getToken()?.accessToken;
    this.baseURL = axios.defaults.baseURL = getEnvironment().api;
    axios.defaults.baseURL = getEnvironment().api;

    axios.interceptors.request.use(
      (req) => {
        const url = req.url;
        const token = getToken();
        if (url && token) {
          req.headers.Authorization = "Bearer " + token.access_token;
        }
        return req;
      },
      (err) => Promise.reject(err)
    );

    axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      (res) => {
        return res;
      },
      async (err) => {
        const statusCode = err.response.status;
        const isExpiredToken =
          err.response.data?.details?.includes("Expired token");
        if (statusCode === 401 || isExpiredToken) {
          if (!window.location.href.includes("login")) {
            deleteToken();
            dispatch(reset());
            OneSignal.logout();
            queryClient.clear();
            return (window.location.href = "/login");
          }
        }
        return Promise.reject(err);
      }
    );
  }

  async authLogin(email: string, password: string) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/v1/auth/login", { email, password })
        .then((result) => {
          resolve(result.data);
        })
        .catch((e) => reject(e));
    });
  }

  async authLoginOTP(token: string, otp: string) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/v1/auth/verify-otp", { token, otp })
        .then((result) => {
          saveToken(result.data.data);
          resolve(result.data);
        })
        .catch((e) => reject(e));
    });
  }

  async resendOTP(token: string) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/v1/auth/resend-otp", { token })
        .then((result) => {
          resolve(result.data);
        })
        .catch((e) => reject(e));
    });
  }

  async authLogout() {
    axios.post("/api/v1/auth/logout").then((result) => {
      deleteToken();
      dispatch(reset());
      OneSignal.logout();
      return (window.location.href = "/login");
    });
  }

  async updateUser() {
    axios.get("/api/v1/auth/me").then((result) => {
      if (result.status) {
        dispatch(update(result.data.data));
      }
    });
  }

  get(url: string, config?: AxiosRequestConfig) {
    return axios.get(url, config);
  }

  post(
    url: string,
    data: Record<string, unknown> | string,
    config?: AxiosRequestConfig
  ) {
    return axios.post(url, data, config);
  }

  put(
    url: string,
    data: Record<string, unknown> | string,
    config?: AxiosRequestConfig
  ) {
    if (isObject(data)) {
      set(data, "_method", "PUT");
    }
    return axios.post(url, data, config);
  }

  delete(url: string, config?: AxiosRequestConfig) {
    return axios.delete(url, config);
  }
}

export const api = new API();
